import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { NegativeBarChartParam, grid } from './negative-bar-interface';
import { NegativeBarService } from './negative-bar.service';
import { ChartResizeService } from '../../service/chart-resize.service';
import { fromEvent } from 'rxjs';
import * as color from '../../config/colors';
import * as backgroundColor from '../../config/backgroundColor';
import { debounceTime } from 'rxjs/operators';
import { ECharts } from 'echarts';
import { initOpts } from '../../config/initOpts';
import { cloneDeep } from 'lodash';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';

export type axisLabelRotate = 'leftSmallAngle' | 'leftBigAngle' | 'rightSmallAngle' | 'rightBigAngle';
@Component({
  selector: 'bcac-negative-bar',
  templateUrl: './negative-bar.component.html',
  styleUrls: ['./negative-bar.component.scss']
})
export class NegativeBarComponent implements OnInit {

  constructor(
    private negativeBarService: NegativeBarService,
    private commonService: CommonService,
    private chartResizeService: ChartResizeService,
    private chartDarkModeService: ChartDarkModeService
  ) { }


  // 图表配置
  echartOption: any = this.negativeBarService.getDefaultOptionOfNegativeBarChart();
  public _bcacChartTitle: { label: string, show: boolean } = { label: "图片名称", show: true };

  // 是否显示标题
  @Input()
  set bcacChartShowTitle(show: boolean) {
    this._bcacChartTitle.show = show;
  }
  // 图标题文字
  @Input()
  set bcacChartTitleText(text: string) {
    this._bcacChartTitle.label = text;
    this._bcacChartFileName = text;
  }
  // 下载图片文件名
  public _bcacChartFileName: string = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }
  // 是否显示toolbox
  @Input()
  set bcacChartShowToolbox(show: boolean) {
    // this.negativeBarService.changeToolboxShow(this.echartOption, show)
    // this.updateOptions()
  }

  // 输入是否显示图例
  @Input()
  set bcacChartShowLegend(bcacLegendShow: boolean) {
    this.negativeBarService.changeLegendShow(this.echartOption, bcacLegendShow);
    this.updateOptions()
  }
  // 单位
  _tooltipUnit = '';
  @Input()
  set bcacTooltipUnit(tooltipUnit: string) {
    this._tooltipUnit = tooltipUnit;
  }
  // 转换数
  _translationNumber: number = 0;
  // /**
  //  * @deprecated
  //  */
  // @Input()
  // set bcacTranslationNumber(translationNum: number) {
  //   this._translationNumber = translationNum;
  // }

  // 设置x轴名
  @Input()
  set bcacXAxisName(xAxisName: string) {
    this.negativeBarService.changeXAxisName(this.echartOption, xAxisName)
    this.updateOptions();
  }
  // 设置y轴名
  @Input()
  set bcacYAxisName(yAxisName: string) {
    this.negativeBarService.changeYAxisName(this.echartOption, yAxisName)
    this.updateOptions();
  }
  // 输入y轴名距离
  @Input()
  set bcacYAxisNameGap(yAxisNameGap: number) {
    this.negativeBarService.changeYAxisNameGap(this.echartOption, yAxisNameGap);
    this.updateOptions();
  }
  // x轴label的旋转 
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: axisLabelRotate) {
    this.negativeBarService.changeXAxisLabelRotate(this.echartOption, xAxisLabelRotate);
    this.updateOptions();
  }
  // y轴label的旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: axisLabelRotate) {
    this.negativeBarService.changeYAxisLabelRotate(this.echartOption, yAxisLabelRotate);
    this.updateOptions();
  }

  public _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(bcacChartLoading: boolean) {
    this._bcacChartLoading = bcacChartLoading;
  }

  bcacData: any = [];
  @Input()
  set bcacChartData(data: NegativeBarChartParam) {
    this.bcacData = data;
    let legendDataArr = [];
    if (data && data.hasOwnProperty('seriesNames')) {

      data.seriesNames.forEach(e => {
        legendDataArr.push(
          {
            label: e,
            value: e,
            checked: true
          }
        );
      });
      this.legendDataArr = legendDataArr;
      this.negativeBarService.changeChartData(this.echartOption, data, this._tooltipUnit);
    }
    this.updateOptions();

    // if (Array.isArray(data)) {
    //   let dataSourceList = [], selectedIndex = 0;
    //   this.bcacData = cloneDeep(data);
    //   if (data.length !== 0) {
    //     this.isNotSingleData = true;
    //   }

    //   data.forEach((element, index) => {
    //     if (element.hasOwnProperty('name')) {
    //       dataSourceList.push({ label: element.name, value: element.name });
    //     }
    //     if (element.selected) {
    //       selectedIndex = index;
    //     }
    //   });

    //   this.sourceList = dataSourceList;
    //   this.selectedData = dataSourceList[selectedIndex].value;
    //   this.negativeBarService.changeChartData(this.echartOption, data[selectedIndex].data, this._tooltipUnit);

    // } else {
    //   this.isNotSingleData = false;
    //   this.negativeBarService.changeChartData(this.echartOption, data, this._tooltipUnit);
    // }
    // this.updateOptions();
  }

  //customToolBox
  customToolBoxRightPosition = "3.5rem";
  @Input()
  set bcacCustomToolBoxRightPosition(value: string) {
    this.customToolBoxRightPosition = value;
  }

  legendDataArr = [];
  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  intervalDatas = [];
  singleSelectIconShow: boolean = false;
  @Input()
  set bcacInterValDatas(value: any[]) {
    if (Array.isArray(value) && value.length > 0) {
      this.intervalDatas = value;
      this.singleSelectIconShow = true;
      if (value.length == 1) {
        this.axisScaleChange(value[0].value);
        this.singleSelectIconShow = false;
      }
    } else {
      this.singleSelectIconShow = false;
    }
  }
  axisScaleChange(e: any) {
    this.negativeBarService.setInterval(this.echartOption, e);
    this.updateOptions();
  }

  legendPosition = "right";  //可选right bottom top none
  @Input()
  set bcacLegendPosition(value: string) {
    this.legendPosition = value;
    this.negativeBarService.setLegendPosition(this.echartOption, this.legendPosition);
    this.updateOptions();
  }

  isSmallMode: boolean = false;
  cardPadding = "1rem";
  @Input()
  set bcacSmallMode(smallMode) {
    if (smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding("0rem");
      this.chartResizeService.openSmallMode(this.echartOption, this.isSmallMode, this.legendPosition)
      // this.chartResizeService.configSplitLine(false, this.echartOption);
      this.updateOptions();
    } else {
      this.isSmallMode = false;
    }
  }

  @Input()
  set bcacAxisSplitLine(axisSplitLineShow: boolean) {
    if (axisSplitLineShow == true) {
      this.chartResizeService.configSplitLine(true, this.echartOption)
    } else {
      this.chartResizeService.configSplitLine(false, this.echartOption)
    }
  }

  @Input()
  set bcacDarkMode(darkMode) {
    this.changeChartTitleColor(darkMode)
    this.changeCardBackgroundColor(darkMode);
    this.chartDarkModeService.openDarkMode(this.echartOption, darkMode)
  }
  @Input()
  set bcacColors(chartColors) {
    if (Array.isArray(chartColors)) {
      this.commonService.changeChartColors(this.echartOption, chartColors)
    }
  }
  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter<ECharts>();

  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, "resize")
      .pipe(debounceTime(200))
      .subscribe(() => {
        // debugger;
        if (this.chartInstance) {
          this.chartResizeService.autoResizeAdapt(this.chartInstance, this.echartOption)
        }
        // this.chartInstance.setOption({
        //   xAxis: {
        //     axisLabel: {
        //       fontSize: style.fontSize - 1
        //     },
        //     nameTextStyle: {
        //       fontSize: style.fontSize
        //     }
        //   },
        //   yAxis: {
        //     axisLabel: {
        //       fontSize: style.fontSize - 1
        //     },
        //     nameTextStyle: {
        //       fontSize: style.fontSize
        //     }
        //   },
        //   legend: {
        //     itemWidth: style.fontSize - 2,
        //     itemHeight: style.fontSize - 2,
        //     textStyle: {
        //       fontSize: style.fontSize - 1
        //     },
        //     pageIconSize: style.fontSize
        //   },
        //   toolbox: {
        //     itemSize: style.toolboxSize,
        //   },
        //   grid: style.rightLegendGrid,
        // });
      });
  }

  chartInstance: ECharts;
  onOptionInit(ec) {
    this.chartInstance = ec;

    this.bcacGetChartInstance.emit(ec);
  }

  // 更新图表
  updateOptions() {
    if (this.chartInstance) {
      this.chartInstance.setOption(this.echartOption, true);
    }
  }

  // 图例改变
  legendChange(e) {
    this.negativeBarService.topLegendChange(e, this.chartInstance);
  }

  // 数据源列表
  sourceList: { name: string, label: string }[] = [];
  // 当前选择数据
  selectedData: string = "";

  isNotSingleData: boolean = false;

  selectedDataChange($event) {
    this.bcacData.forEach(element => {
      if (element.name === $event) {
        this.negativeBarService.changeChartData(this.echartOption, element.data, this._tooltipUnit)
        this.updateOptions();
      }
    })
  }

  changeCardPadding(cardPadding: string) {
    this.cardPadding = cardPadding;
  }

  chartTitleColor = '';
  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this.chartTitleColor = ''
    } else {
      this.chartTitleColor = color.darkModeTextColor;
    }
  }

  cardBgColor = '';
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this.cardBgColor = darkMode;
    } else if (darkMode) {
      this.cardBgColor = backgroundColor.darkModeBGColor;
    }
  }

}
